/**
 * Module dependencies.
 */

import { useEffect } from 'react';

/**
 * Constants.
 */

const appToken = process.env.NEXT_PUBLIC_CHATBOT_APP_TOKEN;
const environment = process.env.NEXT_PUBLIC_CHATBOT_ENVIRONMENT;
const tab = process.env.NEXT_PUBLIC_CHATBOT_TAB;
const baseUrl = 'https://chatwidget-flows2-0.visor.ai';
const containerId = 'example-widget-container';

/**
 * Export `Chatbot` component.
 */

export function Chatbot() {
  useEffect(() => {
    // Gated by the presence of the app token; also prevents double injection on
    // fast-refresh / remount.
    if (!appToken || document.getElementById(containerId)) {
      return;
    }

    // Visor derives its asset base path from `#example-widget-container`.children[0].src,
    // so the widget script must be the first child of a div with this exact id.
    const container = document.createElement('div');

    container.id = containerId;

    const widgetScript = document.createElement('script');

    widgetScript.src = `${baseUrl}/dist/js/visor.js`;

    widgetScript.onload = () => {
      window.Visor?.init({ apptoken: appToken, environment, tab });
    };

    container.appendChild(widgetScript);
    document.body.appendChild(container);

    const socketScript = document.createElement('script');

    socketScript.src = `${baseUrl}/socket.io/socket.io.js`;
    document.body.appendChild(socketScript);
  }, []);

  return null;
}
